import { AdminService } from 'Services/axios/Admin.Service';
import { handleApiError } from 'Features/Common/ErrorHandler';
import { toast } from "react-toastify";

export const fetchAdmins = async (dispatch, filters) => {
    try {
        const response = await AdminService.getDetail(filters);
        return response.data.data;
    } catch (error) {
        console.log(error);
        handleApiError(error);
        throw error;
    }
}

export const fetchAdmin = async (dispatch, filters) => {
    try {
        const response = await AdminService.getDetail(filters);
        return response.data;
    } catch (error) {
        console.log(error);
        handleApiError(error);
        throw error;
    }
}

export const handleSetPermission = async (dispatch, id, payload) => {
    try {
        const data = {
            permissions: payload
        }
        const response = await AdminService.setPermission(id, data);
        toast.success("Permission berhasil diubah", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        handleApiError(error);
        throw error;
    }
}

export const handleChangePassword = async (payload) => {
    try {
        const response = await AdminService.changePassword(payload);
        toast.success("Password berhasil diubah", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.data;
    } catch (error) {
        console.log(error);
        handleApiError(error);
        throw error;
    }
}